module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('el-alert', {
      attrs: {
        "title": "中药汤方",
        "type": "info",
        "center": "",
        "closable": false
      }
    })], _vm._v(" "), _c('el-collapse', {
      attrs: {
        "accordion": ""
      }
    }, _vm._l((_vm.foldData), function(item, index) {
      return _c('el-collapse-item', {
        key: index,
        attrs: {
          "name": index,
          "title": item.recipeName
        }
      }, [_c('el-table', {
        attrs: {
          "data": item.recipeItemResponses,
          "border": "",
          "row-class-name": _vm.tableRowClassName
        }
      }, [_c('el-table-column', {
        attrs: {
          "type": "index",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "value",
          "label": "药品名称",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "label": "数量",
          "width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('el-input', {
              attrs: {
                "size": "small",
                "placeholder": "请输入内容"
              },
              on: {
                "change": function($event) {
                  return _vm.numberchangeAccordion($event, scope.$index, index)
                }
              },
              model: {
                value: (scope.row.number),
                callback: function($$v) {
                  _vm.$set(scope.row, "number", $$v)
                },
                expression: "scope.row.number"
              }
            })]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "recordNumber",
          "label": "库存数量",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "inventoryWarning",
          "label": "库存预警",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "unit",
          "label": "单位",
          "width": "auto"
        }
      }), _vm._v(" "), (_vm.priceSwitchVal) ? _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "retailPrice",
          "label": "单价",
          "width": "auto"
        }
      }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "操作",
          "width": "120"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('el-button', {
              attrs: {
                "type": "text",
                "size": "small"
              },
              nativeOn: {
                "click": function($event) {
                  $event.preventDefault();
                  return _vm.deleteRows(scope.$index, item.recipeItemResponses, index)
                }
              }
            }, [_vm._v("移除\n                        ")])]
          }
        }], null, true)
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "add"
      }, [_c('el-autocomplete', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "fetch-suggestions": _vm.querySearchAsync,
          "placeholder": "请输入内容"
        },
        on: {
          "select": _vm.handleSelects
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.location(index)
          }
        },
        model: {
          value: (_vm.rowDatas),
          callback: function($$v) {
            _vm.rowDatas = $$v
          },
          expression: "rowDatas"
        }
      })], 1), _vm._v(" "), _c('el-form', {
        staticStyle: {
          "margin-top": "30px"
        },
        attrs: {
          "label-position": _vm.labelPosition,
          "label-width": "130px"
        }
      }, [_c('el-form-item', {
        attrs: {
          "label": "中药汤方名："
        }
      }, [
        [_c('el-select', {
          attrs: {
            "placeholder": "请选择中药汤方名"
          },
          model: {
            value: (item.recipeName),
            callback: function($$v) {
              _vm.$set(item, "recipeName", $$v)
            },
            expression: "item.recipeName"
          }
        }, _vm._l((_vm.cfName), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      ], 2), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "副数："
        }
      }, [_c('el-input-number', {
        attrs: {
          "type": "number",
          "min": 1
        },
        model: {
          value: (item.quantity),
          callback: function($$v) {
            _vm.$set(item, "quantity", $$v)
          },
          expression: "item.quantity"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "药袋价格："
        }
      }, [_c('el-input-number', {
        attrs: {
          "type": "number",
          "min": 1
        },
        model: {
          value: (item.bagsCost),
          callback: function($$v) {
            _vm.$set(item, "bagsCost", $$v)
          },
          expression: "item.bagsCost"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "系数："
        }
      }, [_c('el-input-number', {
        attrs: {
          "precision": 1,
          "min": 1
        },
        model: {
          value: (item.coefficient),
          callback: function($$v) {
            _vm.$set(item, "coefficient", $$v)
          },
          expression: "item.coefficient"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "煎服法："
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "请输入煎服法"
        },
        model: {
          value: (item.eatType),
          callback: function($$v) {
            _vm.$set(item, "eatType", $$v)
          },
          expression: "item.eatType"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "忌口及日常护理："
        }
      }, [_c('el-input', {
        attrs: {
          "autosize": "",
          "type": "textarea",
          "placeholder": "请输入忌口及日常护理"
        },
        model: {
          value: (item.note),
          callback: function($$v) {
            _vm.$set(item, "note", $$v)
          },
          expression: "item.note"
        }
      })], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "inOne-TabBttom"
      }, [_c('el-button', {
        attrs: {
          "type": "warning"
        },
        on: {
          "click": function($event) {
            return _vm.preserveRemind(index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-floppy-o"
      }), _vm._v("保存\n                ")])], 1)], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "15px"
      }
    }), _vm._v(" "), [_c('el-alert', {
      attrs: {
        "title": "新增中药汤方",
        "type": "info",
        "center": "",
        "closable": false
      }
    })], _vm._v(" "), _c('div', {
      staticClass: "inOne-advice",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [
      [_c('span', {
        staticClass: "titleText"
      }, [_vm._v("组方：")]), _vm._v(" "), _c('el-select', {
        attrs: {
          "filterable": "",
          "placeholder": "请选择"
        },
        on: {
          "change": _vm.selectVariation
        },
        model: {
          value: (_vm.noncorresponding.input),
          callback: function($$v) {
            _vm.$set(_vm.noncorresponding, "input", $$v)
          },
          expression: "noncorresponding.input"
        }
      }, _vm._l((_vm.medicalRecipe), function(item, index) {
        return _c('el-option', {
          key: index,
          attrs: {
            "value": item.zufangLogo
          }
        })
      }), 1)], _vm._v(" "), [_c('span', {
        staticClass: "titleText"
      }, [_vm._v("系数：")]), _vm._v(" "), _c('el-input-number', {
        attrs: {
          "precision": 1,
          "min": 1
        },
        model: {
          value: (_vm.coefficient),
          callback: function($$v) {
            _vm.coefficient = $$v
          },
          expression: "coefficient"
        }
      })]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "inOne-table"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.tableData,
        "border": "",
        "row-class-name": _vm.tableRowClassName
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index",
        "width": "auto"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "prop": "value",
        "label": "药品名称",
        "width": "auto"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "label": "数量",
        "width": "auto"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "small",
              "placeholder": "请输入内容"
            },
            on: {
              "change": function($event) {
                return _vm.numberchange($event, scope.$index)
              }
            },
            model: {
              value: (scope.row.number),
              callback: function($$v) {
                _vm.$set(scope.row, "number", $$v)
              },
              expression: "scope.row.number"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "prop": "recordNumber",
        "label": "库存数量",
        "width": "auto"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "prop": "inventoryWarning",
        "label": "库存预警",
        "width": "auto"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "prop": "unit",
        "label": "单位",
        "width": "auto"
      }
    }), _vm._v(" "), (_vm.priceSwitchVal) ? _c('el-table-column', {
      attrs: {
        "align": "center",
        "prop": "retailPrice",
        "label": "单价",
        "width": "auto"
      }
    }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.deleteRow(scope.$index, _vm.tableData)
              }
            }
          }, [_vm._v("移除\n                    ")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.substitute(scope.$index, scope.row)
              }
            }
          }, [_vm._v("替换\n                    ")])]
        }
      }])
    })], 1), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "药品替换",
        "visible": _vm.dialogFormVisible,
        "width": "35%"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    }, [
      [_c('el-select', {
        attrs: {
          "placeholder": "请选择替换的药品"
        },
        on: {
          "change": _vm.select_Variation
        },
        model: {
          value: (_vm.val),
          callback: function($$v) {
            _vm.val = $$v
          },
          expression: "val"
        }
      }, _vm._l((_vm.cfArr), function(item, index) {
        return _c('el-option', {
          key: index,
          attrs: {
            "label": item.value,
            "value": item.id
          }
        })
      }), 1)], _vm._v(" "), _c('div', {
        staticClass: "dialog-footer",
        attrs: {
          "slot": "footer"
        },
        slot: "footer"
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            _vm.dialogFormVisible = false
          }
        }
      }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": _vm.sure
        }
      }, [_vm._v("确 定")])], 1)
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "add"
    }, [_c('el-autocomplete', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "fetch-suggestions": _vm.querySearchAsync,
        "placeholder": "请输入内容"
      },
      on: {
        "select": _vm.handleSelect
      },
      model: {
        value: (_vm.rowData),
        callback: function($$v) {
          _vm.rowData = $$v
        },
        expression: "rowData"
      }
    })], 1), _vm._v(" "), _c('el-form', {
      attrs: {
        "label-position": _vm.labelPosition,
        "label-width": "130px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "中药汤方名："
      }
    }, [
      [_c('el-select', {
        attrs: {
          "placeholder": "请选择中药汤方名"
        },
        model: {
          value: (_vm.recipeName),
          callback: function($$v) {
            _vm.recipeName = $$v
          },
          expression: "recipeName"
        }
      }, _vm._l((_vm.cfName), function(item) {
        return _c('el-option', {
          key: item.value,
          attrs: {
            "label": item.label,
            "value": item.value
          }
        })
      }), 1)]
    ], 2), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "副数："
      }
    }, [_c('el-input-number', {
      attrs: {
        "type": "number",
        "min": 1
      },
      model: {
        value: (_vm.quantity),
        callback: function($$v) {
          _vm.quantity = $$v
        },
        expression: "quantity"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "药袋价格："
      }
    }, [_c('el-dropdown', {
      on: {
        "command": _vm.handleCommand
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入或选择药袋价格"
      },
      model: {
        value: (_vm.drugPrice),
        callback: function($$v) {
          _vm.drugPrice = $$v
        },
        expression: "drugPrice"
      }
    }), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, [_vm._l((_vm.medicineBag), function(item, index) {
      return [_c('el-dropdown-item', {
        attrs: {
          "command": item.value
        }
      }, [_vm._v(_vm._s(item.label))])]
    })], 2)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "煎服法："
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入煎服法"
      },
      model: {
        value: (_vm.eatType),
        callback: function($$v) {
          _vm.eatType = $$v
        },
        expression: "eatType"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "忌口及日常护理："
      }
    }, [_c('el-input', {
      attrs: {
        "autosize": "",
        "type": "textarea",
        "placeholder": "请输入忌口及日常护理"
      },
      model: {
        value: (_vm.note),
        callback: function($$v) {
          _vm.note = $$v
        },
        expression: "note"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inOne-TabBttom"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.handleSubmit()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _vm._v("保存\n        ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.handleReset()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("重置\n        ")])], 1)
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea3b8c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/inquiryAdvices.vue
// module id = 1019
// module chunks = 2